(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) {
          this.currentScrollTop = scrollTop;
          return;
        }

        requestAnimationFrame(this.hide.bind(this));
      } else if ((scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) || this.preventHide) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      document.body.classList.remove('has-sticky-header');
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      document.body.classList.add('has-sticky-header');
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      document.body.classList.remove('has-sticky-header');
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('search-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram"] && !Shopify.designMode) return;
  try {
    
  if (typeof Showcase === 'undefined') {
    Showcase = {};
  }

  class InstagramFeed extends HTMLElement {
    constructor() {
      super();

      this.initialized = false;
      // TODO: Test with reduced network speeds to see if larger timeout is needed
      this.timeout = 200;
      this.onLoad = debounce(this.handleLoad.bind(this), this.timeout);

      Showcase.loadMedia = this.onLoad;
    }

    handleLoad() {
      if (this.initialized) return;

      const items = this.querySelectorAll('.showcase-grid-item');
      const sliderControls = this.querySelectorAll('.showcase-slider-control i');
      console.log('sliderControls', sliderControls);

      items?.forEach(item => item.classList.add('scroll-animate__item'));
      sliderControls?.forEach(control => control.classList.add('scroll-animate__end'));

      callOnLoad(this.init.bind(this));
    }

    init() {
      initScrollParent(this);
      this.initialized = true;
    }
  }

  customElements.define('instagram-feed', InstagramFeed);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"]) return;
  try {
    
  // TODO: Add logic to prevent scrolling on open and disable on close
  class ProductReviews extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.observe();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    observe() {
      this.observer = new MutationObserver((mutationList, observer) => {
        for (const mutation of mutationList) {
          if (mutation.type === 'childList') {
            const addedNode = mutation.addedNodes[0];

            if (addedNode?.classList?.contains('bv-mbox-lightbox')) {
              addedNode.style.top = '';

              const mboxSelects = addedNode.querySelectorAll('select');

              mboxSelects.forEach(select => {
                Select.bind(select);
                select.parentElement.classList.add('is-fancy');
              });

              document.body.classList.add('overflow-hidden');
              const closeButton = addedNode.querySelector('.bv-mbox-close');

              if (closeButton) {
                closeButton.addEventListener('click', () => document.body.classList.remove('overflow-hidden'));
              }
            }
          }
        }
      });

      this.observer.observe(document.body, {
        childList: true,
      });
    }
  }

  customElements.define('product-reviews', ProductReviews);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rewards-redeem"]) return;
  try {
    
  class RewardsRedeem extends HTMLElement {
    constructor() {
      super();

      this.list = this.querySelector('[data-lion-rewards-list]');
    }

    connectedCallback() {
      this.initObserver();
    }

    initObserver() {
      this.observer = new MutationObserver((mutationList, observer) => {
        for (const mutation of mutationList) {
          if (mutation.type === 'childList') {
            const rewards = this.list.querySelectorAll('.lion-reward-item');

            // TODO: Do check first for addedNodes (same for initScrollParent below)
            rewards.forEach(reward => {
              reward.classList.add('scroll-card');
            });

            initScrollParent(this);

            observer.disconnect();
          }
        }
      });

      this.observer.observe(this.list, {
        childList: true,
      });
    }
  }

  customElements.define('rewards-redeem', RewardsRedeem);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rewards-rules"]) return;
  try {
    
  class RewardsRules extends HTMLElement {
    constructor() {
      super();

      this.list = this.querySelector('[data-lion-rules-list]');
      this.modalClasses = ['overflow-hidden', 'has-open-modal', 'has-open-modal--rewards-rules'];
    }

    connectedCallback() {
      this.initObserver();
    }

    initObserver() {
      this.observer = new MutationObserver((mutationList, observer) => {
        for (const mutation of mutationList) {
          if (mutation.type === 'childList') {
            const rules = this.list.querySelectorAll('.lion-rule-item');
            const buttonEls = this.list.querySelectorAll('.lion-action-button');
            const loyaltyModalEls = document.querySelector('#loyaltylion');

            // TODO: Do check first for addedNodes (same for initScrollParent below)
            rules.forEach(rule => {
              rule.classList.add('scroll-animate__item');
            });

            if (buttonEls.length) {
              buttonEls.forEach(buttonEl => {
                const rule = buttonEl.closest('.lion-rule-item');
                const isReferral = rule.classList.contains('lion-rule-item--referral');
                const isBirthday = rule.classList.contains('lion-rule-item--birthday');

                if (isBirthday) {
                  if (buttonEl.classList.contains('lion-rule-item__button--disabled')) {
                    rule.classList.add('lion-rule-item--completed-forever');
                  }
                }

                buttonEl.addEventListener('click', e => {
                  setTimeout(() => {
                    const modalEl = document.querySelector('.lion-modal-and-screen', loyaltyModalEls);
                    const closeEls = [
                      '.lion-screen',
                      '.lion-modal__close-button, .lion-referral-widget-modal__close-button',
                      '.lion-redeem-reward-modal__button',
                    ];

                    if (modalEl) {
                      document.body.classList.add(...this.modalClasses);
                      closeEls.forEach(el => this.addCloseListener(el));

                      if (isReferral) {
                        const referralFields = modalEl.querySelectorAll('.lion-referral-email-form__field');
                        referralFields.forEach(field => {
                          const label = field.querySelector('.lion-referral-email-form__label');
                          
                          if (label) field.appendChild(label);
                        });
                      } else if (isBirthday) {
                        const monthSelect = modalEl.querySelector('.lion-birthday-entry-form__select--month');

                        if (monthSelect) Select.bind(monthSelect, { placeholder: 'Month' });
                      }
                    }
                  });
                });
              });
            }

            initScrollParent(this);

            observer.disconnect();
          }
        }
      });

      this.observer.observe(this.list, {
        childList: true,
      });
    }

    addCloseListener(el) {
      el = typeof el === 'string' ? document.querySelector(el) : el;
      el?.addEventListener('click', () => document.body.classList.remove(...this.modalClasses));
    }
  }

  customElements.define('rewards-rules', RewardsRules);

  } catch(e) { console.error(e); }
})();
})();
